/** @prettier */
import { KYC_FLOWS } from '@xanadu/ui-shared/constants';

import { REPORTS_LINKS } from '../common/constants';
import ACCOUNT_DETAILS_FIELDS from '../common/constants/accountPersonalDetailsFields';

import Homepage from '../common/components/Homepage';

import Account from '../common/pages/AccountPages';
import Affiliates from '../common/pages/Affiliates';
import Colossus from '../common/pages/Colossus';
import GlobalEventsPage from '../common/pages/GlobalEventsPage';
import PromoPage from '../common/pages/PromoPage';
import PromotionsPage from '../common/pages/PromotionsPage';
import Reports from '../common/pages/Reports';
import StaticPage from '../common/pages/StaticPage';

export const BRAND = 'easybet';

export const featuresFlags = {
  alderneyRegulation: false,
  availableMobileReports: ['transaction-history', 'settled'],
  cashierEnabled: true,
  casinoEnabled: false,
  crawlingEnabled: false,
  displayAdvancedRaceData: false,
  displayAffiliateProgram: true,
  displayFundProtect: true,
  editActiveOffer: false,
  enterKeyEnabled: false,
  feedbackEnabled: false,
  iconKeys: ['Deduction Factor', 'Free Bet', 'Unmatched Bet', '3rd Party'],
  individualBetSubmission: false,
  keepInPlayEnabled: false,
  liveChatEnabled: true,
  oddsLockerEnabled: false,
  priceDepth: 3,
  promotionsEnabled: true,
  raceCardsEnabled: true,
  showBetBuilderEventName: false,
  showCasinoActivityReports: false,
  showColossus: true,
  showMarketingReminder: false,
  showMatchedVolume: true,
  showOverrounds: false,
  showPopularProducts: false,
  showUnmatchedBetIcon: false,
  showUnsubmittedVerticalBar: false,
  singleExchangeType: true,
  singleOddsType: true,
  subProductsEnabled: [],
  externalProductsEnabled: [],
  topBusinessLinksEnabled: false,
  switchSiteLayout: false,
  excludedMarketSportsGraph: ['greyhound-racing', 'horse-racing'],
};

export const routes = [
  {
    exact: true,
    path: '/(bonuses|registration|login|reset-password|tour)?',
    component: Homepage,
    props: {
      childrenProps: {
        EventTime: {
          layout: 'large',
        },
        Event: {
          distantNameLink: true,
          hideCompetitions: false,
        },
      },
    },
  },
  {
    exact: false,
    path: '/events',
    component: GlobalEventsPage,
    props: {
      childrenProps: {
        Event: {
          distantNameLink: true,
        },
        SingleEventPageMarket: {
          backLayAllEnabled: false,
          showInPlayAndMultipleIcons: false,
        },
        EventsPageHeader: {
          useBreadcrumbs: true,
        },
      },
    },
  },
  {
    exact: false,
    path: '/partners/affiliates',
    component: Affiliates,
  },
  {
    exact: false,
    path: '/page',
    component: StaticPage,
  },
  {
    exact: false,
    path: '/colossus',
    component: Colossus,
  },
  {
    path: '/account',
    component: Account,
    props: {
      tabs: [
        {
          key: 'account-balances',
          'label-key': 'Account Balances',
          value: 'account-balances',
          href: '/account/account-balances',
        },
        {
          key: 'general-settings',
          'label-key': 'Settings',
          value: 'general-settings',
          href: '/account/general-settings',
        },
        {
          key: 'safer-gambling',
          'label-key': 'Safer Gambling',
          value: 'safer-gambling',
          href: '/account/safer-gambling',
        },
        {
          key: 'verification',
          'label-key': 'Account Verification',
          value: 'verification',
          href: '/account/verification',
        },
      ],
      childrenProps: {
        Tabs: {
          fatherComponent: '',
        },
      },
    },
  },
  {
    exact: false,
    path: '/promotions/:section?/:promoId?',
    component: PromotionsPage,
  },
  {
    exact: false,
    path: '/promo/:promoUrl?',
    component: PromoPage,
  },
  {
    path: '/reports',
    component: Reports,
  },
];

export const customization = {
  navigationLayout: 'isolated',
  searchPosition: 'content',
  searchPlaceholder: 'custom',
  Login: {
    backButtonType: 'primary',
    secondaryButtonInverted: true,
  },
  BasicButtons: {
    backButtonType: 'flat',
    backButtonInverted: true,
  },
  BetBuilderLeg: {
    betBuilderIconPosition: 'left-right',
  },
  Betslip: {
    footerLayout: 'simple',
    dimension: 'wide', // [slim, standard, wide] ¯\_(ツ)_/¯
  },
  BetslipMultiples: {
    multiplesLayout: 'bullet',
  },
  BetslipOffer: {
    betFeedbackLayout: 'simple',
  },
  BetslipOfferButtons: {
    offerEditButtons: 'simple',
  },
  BetslipOfferInfo: {
    optionsDirection: 'top',
  },
  ContentFooter: {
    displayedSections: [
      { category: 'about', 'label-key': 'About Us' },
      { category: 'getting_started', 'label-key': 'Getting Started' },
      { category: 'faqs', 'label-key': 'FAQs' },
      { category: 'responsible_gaming', 'label-key': 'Safer Gambling' },
      { category: 'rules_and_regulations', 'label-key': 'Rules & Regs' },
    ],
    showPoweredBy: true,
  },
  ExchangeBettingModal: {
    placeBetButtonType: 'primary',
  },
  CustomerOnBoarding: {
    theme: 'light',
    textContent: [
      'Pick a side. Bet YES or NO on the biggest questions in sport, politics, and culture.',
      'Back, lay and trade on the "easyBet" Exchange.',
      'Get best priced Multiples and Bet Builders the easy way.',
      'Click ”Join Now”, or ”Take a Tour” to learn more.',
    ],
  },
  Header: {
    displaySubHeader: true,
    forceLongLogo: true,
    childrenProps: {
      SubHeader: {
        brokerageLinkEnabled: false,
        insightLinkEnabled: false,
      },
    },
  },
  MobileFooter: {
    items: [
      { id: 'home', label: 'home' },
      { id: 'menu', label: 'Menu' },
      { id: 'betslip', label: 'My Bets' },
      { id: 'multiples', label: 'Multiples' },
      { id: 'promotions', label: 'Promos' },
    ],
  },
  MultiplesBulletLayout: {
    optionsDirection: 'top',
  },
  Reports: {
    dropdownLayout: 'outlined',
  },
  PromoPage: {
    joinText: 'Join easyBet',
    trustPilotTitle: "The UK's most trusted Betting Exchange",
    renderPartnerLogos: null,
  },
  ResetPassword: {
    showPoweredBy: true,
    showTrustPilot: false,
    showLogo: false,
  },
  SingleEventPage: {
    showMatchedAmount: true,
    useEventNameMultiLine: true,
    streamingLayout: 'inline',
    showLiveStreamingIcon: false,
  },
  TransactionReports: {
    dropdownLayout: 'outlined',
  },
  AccountPagesSettings: {
    accountLinks: REPORTS_LINKS,
    displayAccountTitleIcon: true,
    displayAccountTitleUsername: true,
    displayBonusSectionAsInline: true,
    displayCashierButtonsIcons: true,
    displayConfirmBetSelector: true,
    displayedDetails: ACCOUNT_DETAILS_FIELDS,
    displayMatchedVolumeSelector: true,
    displayOverroundsSelector: true,
  },
};

const config = {
  brand: BRAND,
  clientDefaultLanguage: 'en-GB',
  clientDefaultCurrency: 'GBP',
  availableLanguages: ['en-GB'],
  excludedSports: [],
  fallbackReleaseDate: new Date('2024-10-30T13:30:00+01:00'),
  homepageBannerPosition: 'top', // [top, bottom, center]
  settings: {
    KYC_FLOW: KYC_FLOWS.MEDIUM,
    MINIMUM_DEPOSIT_AMOUNT: 10,
  },
  featuresFlags,
  routes,
  customization,
};

export default config;
